import React, { useState } from "react";
import { ChevronDown, ChevronUp, MapPin, Target, User, Building2 } from "lucide-react";

const InfoLine = ({ icon: Icon, label, value }) => {
  if (!value) return null;
  return (
    <div className="flex items-start gap-2">
      <Icon size={14} className="mt-0.5 flex-shrink-0 text-blue-950" />
      <div>
        <p className="text-xs text-gray-500">{label}</p>
        <p className="text-sm text-gray-800">{value}</p>
      </div>
    </div>
  );
};

const ContactRequestContext = ({ request }) => {
  const [expanded, setExpanded] = useState(false);

  if (!request) return null;

  return (
    <div className="border-b border-gray-200 bg-gray-50 px-4 py-3">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="flex w-full items-center justify-between text-left"
      >
        <span className="text-xs font-medium uppercase tracking-wide text-gray-500">
          Solicitud de contacto
        </span>
        {expanded ? (
          <ChevronUp size={16} className="text-gray-400" />
        ) : (
          <ChevronDown size={16} className="text-gray-400" />
        )}
      </button>

      {expanded && (
        <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2">
          <InfoLine icon={Target} label="Oportunidad" value={request.opportunity_type} />
          <InfoLine icon={MapPin} label="Ubicación" value={request.location} />
          <InfoLine icon={User} label="Atención" value={request.attention_reason} />
          <InfoLine icon={Building2} label="Buscando" value={request.looking_for} />
        </div>
      )}
    </div>
  );
};

export default ContactRequestContext;
